import { NewPasswordForm } from 'components/site/forms/Access/NewPasswordForm';
import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import qs from 'query-string';
import { useEffect, useState } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const SetNewPasswordPageContent = (props: Props) => {
    const [email, setEmail] = useState('');
    const [hash, setHash] = useState('');

    useEffect(() => {
        const params = qs.parse(location.search);
        setEmail(params['email'] as string);
        setHash(params['hash'] as string);
    }, []);

    return (
        <S_SetNewPasswordPageContent className={props.className}>
            {email && hash ? (
                <NewPasswordForm email={email} hash={hash} />
            ) : (
                <S_Message type="warning">{Localization.INVALID_LINK}</S_Message>
            )}
        </S_SetNewPasswordPageContent>
    );
};

const S_SetNewPasswordPageContent = styled.div`
    display: flex;
    width: 100%;
`;

const S_Message = styled(Message)``;
